export default () => ({
  trigger: {
    name: 'order_block.show_order_type',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: 'order_type',
      },
    },
    nonInt: true,
  },
});
